import request from '@/utils/request'

/**
 * 注册管理员
 * @param  {String} options     注册信息
 * @return {Promise}
 */
export function postRegister(data: any) {
  return request({
    url: '/api/admin/register',
    data,
    method: 'post'
  })
}

// 获取用户信息
export function getUserInfo(data?: any) {
  return request.get('/api/admin/info', data)
}

// 账号密码登录
export function accountLogin(requestOptions: any) {
  return request({
    url: '/admin/user/login',
    method: 'post',
    ...requestOptions
  })
}

// 新增用户信息
export function requestAddUser(data?: any) {
  return request.post('/admin/user/add', data)
}

// 更新用户信息
export function requestUpdateUser(data?: any) {
  return request.post('/admin/user/edit', data)
}

// 修改用户密码
export function requestChangePasswordUser(data?: any) {
  return request.post('/admin/user/change_password', data)
}

// 删除用户
export function requestDeleteUser(data?: any) {
  return request.post('/admin/user/delete', data)
}

// 审核用户 /admin/user/audit
export function requestAuditUser(data?: any) {
  return request.post('/admin/user/audit', data)
}

// 获取用户列表
export function getUserList(data?: any) {
  return request.get('/admin/user/list', { params: data })
}

// 上传图片
export function uploadImage(data?: any) {
  return request.post('/api/tool/uploads', data)
}
